import React, { useContext, useEffect, useState } from "react";

// STORAGE
import FullPageExportContext from "../../../../store/fullPageExportContext";

// COMPONENTS
import Wrapper from "../../../../components/helpers/Wrapper";
import Tab from "../../../../components/ui/Tab";

// PAGES
import LinkedinAllVideosOrganic from "./LinkedinAllVideosOrganic";
import LinkedinAllVideosOverall from "./LinkedinAllVideosOverall";
import LinkedinAllVideosPaid from "./LinkedinAllVideosPaid";

// UTILS
import { IAEvent_Primary_Tab_Visit } from "../../../../utils/IAEvents";

export default function LinkedinAllVideos({ videoDurationType, topCardData }) {
  const { setExportPageName } = useContext(FullPageExportContext);

  const tabData = ["Overall", "Organic", "Paid"];
  const [selectedTab, setSelectedTab] = useState(tabData[0]);

  const handleCallback = (event) => {
    if (selectedTab !== event) {
      setSelectedTab(event);
    }
    IAEvent_Primary_Tab_Visit("Marketing Intelligence", "Video", "Linkedin", event)
  };
  useEffect(() => {
    setExportPageName("Video Linkedin " + selectedTab)
  }, [selectedTab])

  return (
    <Wrapper>
      <div className="grid grid_margin_bottom">
        <Tab
          varient={"secondary"}
          tabData={tabData}
          activeTab={selectedTab}
          handleCallback={(event) => handleCallback(event)}
        />
      </div>
      {selectedTab.toLowerCase() === tabData[0].toLowerCase() && <LinkedinAllVideosOverall videoDurationType={videoDurationType} topCardData={topCardData} />}
      {selectedTab.toLowerCase() === tabData[1].toLowerCase() && <LinkedinAllVideosOrganic videoDurationType={videoDurationType} topCardData={topCardData} />}
      {selectedTab.toLowerCase() === tabData[2].toLowerCase() && <LinkedinAllVideosPaid videoDurationType={videoDurationType} topCardData={topCardData} />}
    </Wrapper>
  );
}
